<label class="label">
    <ng-content></ng-content>
</label>

<div class="valueLabel"><ng-content select="[value]"></ng-content></div>
